document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.pawdx-header');
  const toggle = document.querySelector('.pawdx-menu-toggle');
  const nav = document.querySelector('.pawdx-nav');

  /* =========================
     Mobile Header Menu
  ========================= */

  if (header && toggle && nav) {
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', function (event) {
      event.stopPropagation();

      const isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 990) {
        header.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* =========================
     Header Scroll State
     Optional class for future styling
  ========================= */

  function updateHeaderScrollState() {
    if (!header) return;

    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  updateHeaderScrollState();
  window.addEventListener('scroll', updateHeaderScrollState, { passive: true });

  /* =========================
     Store Subnav Tabs
     Works only if later we add:
     data-pawdx-tab-button="oral-health"
     data-pawdx-tab-panel="oral-health"
  ========================= */

  const tabButtons = document.querySelectorAll('[data-pawdx-tab-button]');
  const tabPanels = document.querySelectorAll('[data-pawdx-tab-panel]');

  if (tabButtons.length && tabPanels.length) {
    tabButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        const target = button.getAttribute('data-pawdx-tab-button');

        tabButtons.forEach(function (btn) {
          btn.classList.remove('active');
        });

        tabPanels.forEach(function (panel) {
          panel.hidden = true;
          panel.classList.remove('active');
        });

        button.classList.add('active');

        const activePanel = document.querySelector('[data-pawdx-tab-panel="' + target + '"]');

        if (activePanel) {
          activePanel.hidden = false;
          activePanel.classList.add('active');
        }
      });
    });
  }

  /* =========================
     Smooth Anchor Scroll
  ========================= */

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (event) {
      const targetId = anchor.getAttribute('href');

      if (!targetId || targetId === '#') return;

      const targetElement = document.querySelector(targetId);

      if (!targetElement) return;

      event.preventDefault();

      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});